import { defaultLanguage, supportedLanguages, type Language } from '@/lib/translations'

export const SITE_URL = (process.env.NEXT_PUBLIC_SITE_URL || 'https://www.authflow.net').replace(/\/$/, '')

export const HREFLANG_BY_LANGUAGE: Record<Language, string> = {
  en: 'en',
  ru: 'ru',
  zh: 'zh',
  it: 'it',
  pt: 'pt',
  ko: 'ko',
  de: 'de',
  pl: 'pl',
  fr: 'fr',
  yue: 'yue-HK',
}

export const OPEN_GRAPH_LOCALE_BY_LANGUAGE: Record<Language, string> = {
  en: 'en_US',
  ru: 'ru_RU',
  zh: 'zh_CN',
  it: 'it_IT',
  pt: 'pt_PT',
  ko: 'ko_KR',
  de: 'de_DE',
  pl: 'pl_PL',
  fr: 'fr_FR',
  yue: 'zh_HK',
}

const normalizePath = (path: string) => (path === '/' ? '' : path.replace(/\/$/, ''))

// `path` is the unprefixed route, e.g. '' or '/pricing'.
export function getLocalizedUrl(path: string, language: Language, baseUrl: string = SITE_URL) {
  const normalized = normalizePath(path)
  if (language === defaultLanguage) {
    return `${baseUrl}${normalized}`
  }
  return `${baseUrl}/${language}${normalized}`
}

// Site-relative link to a route in the given language, e.g. '/de/pricing'.
export function getLocalizedPath(path: string, language: Language) {
  return getLocalizedUrl(path, language, '') || '/'
}

export function getHreflangAlternates(path: string, baseUrl: string = SITE_URL) {
  const languages: Record<string, string> = {}
  for (const language of supportedLanguages) {
    languages[HREFLANG_BY_LANGUAGE[language]] = getLocalizedUrl(path, language, baseUrl)
  }
  languages['x-default'] = getLocalizedUrl(path, defaultLanguage, baseUrl)
  return languages
}

// Self-referencing canonical plus the full hreflang set for this page.
export function getLocaleAlternates(path: string, language: Language) {
  return {
    canonical: getLocalizedUrl(path, language),
    languages: getHreflangAlternates(path),
  }
}
